/* @flow */
import { toCamelCase } from 'atpjs/helpers/string'
import i18n from 'atpjs/helpers/i18n'

export const formatPhone = (phone: string) => {
  return phone
    .replace(/^(\+[\d]{2})([\d]{2})([\d]{3})([\d]{2})([\d]{2})$/, '$1 $2 $3 $4 $5')
    .replace(/^(0[\d]{2})([\d]{3})([\d]{2})([\d]{2})$/, '$1 $2 $3 $4')
}

export const formatPhoneForTel = (phone: string) => {
  return phone.replace(/^0([\d]{2})([\d]{3})([\d]{2})([\d]{2})$/, '+41$1$2$3$4')
}

export const computePhone = (data) => {
  const customerCenter = data.get('customerCenter')
  const customerType = data.get('customerType') || 'private'
  const phoneNumber = customerCenter
    ? customerCenter.get(toCamelCase(`phone_number_${i18n.locale}`))
    : i18n.trans(['contactPhoneNumber', customerType])
  return [formatPhone(phoneNumber), formatPhoneForTel(phoneNumber)]
}
